import React from 'react';

const Footer = () => (
  <footer className="border-t border-border bg-background py-6 text-foreground">
    <div className="container mx-auto px-4 text-center">
      <p className="text-sm font-heading">
        © {new Date().getFullYear()} JAPAN TRADING CARD CENTER Co., Ltd.
      </p>
    </div>
  </footer>
);

export default Footer;
